import {
    CHANGE_DATE_START,
    CHANGE_DATE_END,
    CLEAR_FILTER_ALL
} from '../actions';
import moment from 'moment'
// import { getYearMontDate } from "../../helpers/Utils";

// let today = moment();
let today = moment();
let filterDayAgo = moment().subtract(7,'d')

const INIT_STATE = {
	dateStart: filterDayAgo,
  dateEnd: today
};

export default (state = INIT_STATE, action) => {
  // console.log(action.payload)
	switch (action.type) {
		case CHANGE_DATE_START:
		  return { ...state, dateStart:action.payload};
    case CHANGE_DATE_END:
		  return { ...state, dateEnd:action.payload};
    case CLEAR_FILTER_ALL:
		  return { ...state, dateStart: filterDayAgo,  dateEnd: today};
		default: return { ...state };
	}
}
